import React, { useEffect, useState } from "react";
import "./UploadButton.css";
import { LuFolderOpen } from "react-icons/lu";
import { FaTimes } from "react-icons/fa";

function UploadButton({ disabled = false, currentFileBase64, showLabel = true, ...props }) {
	const [selectedImage, setSelectedImage] = useState(null);
	const [dragActive, setDragActive] = useState(false);

	useEffect(() => {
		if (currentFileBase64) {
			setSelectedImage(currentFileBase64);
		}
	}, [currentFileBase64])

	if (props.simple) {
		const changeHandler = (event) => {
			const file = event.target.files[0];
			if (file) {
				if (props.onFileChanged) {
					props.onFileChanged(file);
				}
			}
		};

		return (
			<button
				type="button"
				className="button-white"
				disabled={disabled}
				onClick={() => document.getElementById("upload-input-simple").click()}
			>
				<LuFolderOpen size={18} />
				{showLabel && (props.label || "Upload Imagem")}
				<input
					id="upload-input-simple"
					className="upload-button-input"
					type="file"
					name="file"
					onChange={changeHandler}
					style={{ display: "none" }}
				/>
			</button>
		);
	}

	const handleFile = (file) => {
		if (file) {
			setSelectedImage(URL.createObjectURL(file));
			if (props.onFileChanged) {
				props.onFileChanged(file);
			}
		}
	};

	const changeHandler = (event) => {
		const file = event.target.files[0];
		handleFile(file);
	};

	const handleDragOver = (event) => {
		event.preventDefault();
		event.stopPropagation();
		setDragActive(true);
	};

	const handleDragLeave = (event) => {
		event.preventDefault();
		event.stopPropagation();
		setDragActive(false);
	};

	const handleDrop = (event) => {
		event.preventDefault();
		event.stopPropagation();
		setDragActive(false);
		const file = event.dataTransfer.files[0];
		handleFile(file);
	};

	const removeImage = (event) => {
		event.stopPropagation();
		setSelectedImage(null);
		if (props.onFileChanged) {
			props.onFileChanged(null);
		}
	};

	return (
		!props.disabled && (
			<div className="upload-container">
				<div
					className={`upload-dropzone ${dragActive ? "active" : ""}`}
					onDragOver={handleDragOver}
					onDragLeave={handleDragLeave}
					onDrop={handleDrop}
					onClick={() => document.getElementById("upload-input").click()}
				>
					{selectedImage ? (
						<div className="uploaded-image-container">
							<button
								type="button"
								className="remove-image-button"
								onClick={removeImage}
							>
								<FaTimes />
							</button>
							<img
								src={selectedImage}
								alt="uploaded"
								className="uploaded-image"
							/>
						</div>
					) : (
						<div className="placeholder">
							<p>
								{props.placeholderText ||
									"Arraste ou clique para adicionar Logo"}
							</p>
						</div>
					)}
					<input
						id="upload-input"
						className="upload-button-input"
						type="file"
						name="file"
						onChange={changeHandler}
					/>
				</div>
			</div>
		)
	);
}

export default UploadButton;
